import type { ReactNode } from 'react';

interface StepHeadingProps {
  title: ReactNode;
  description: ReactNode;
}

export function StepHeading({ title, description }: StepHeadingProps) {
  return (
    <div>
      <h2 className="text-xl font-semibold text-hilevel-slate tracking-tight">{title}</h2>
      <p className="text-sm text-hilevel-gray mt-1">{description}</p>
    </div>
  );
}
